import BaseModel from '../BaseModel';

export default class SystemNotification extends BaseModel {
  static entity = 'systemNotifications';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      routeTo: this.string(null).nullable(),
      routeToId: this.attr(null).nullable(),
      notificationHeader: this.string(null).nullable(),
      notificationText: this.string(null).nullable(),
      viewedAt: this.attr(null).nullable(),
      createdAt: this.attr(null).nullable(),
    };
  }

  static state() {
    return {
      ...super.state(),
      total: 0,
      perPage: 20,
      currentPage: 0,
      lastPage: 0,
      unreadCount: 0,
    };
  }

  static getMetaData() {
    const {
      total, perPage, currentPage, lastPage,
    } = this.store().state.entities[this.entity];

    return {
      total, perPage, currentPage, lastPage,
    };
  }

  static getUnreadCount() {
    return this.store().state.entities[this.entity].unreadCount || 0;
  }

  static isRead(notification) {
    return !!notification?.viewedAt;
  }

  static normalizeItem(notification) {
    return {
      ...notification,
    };
  }

  static async index(params = {}) {
    if (params.page === 1) {
      await this.deleteAll();
    }

    const request = await this.api().fetchAll(params);
    const { data, meta } = request.response.data;

    if (data?.length) {
      await this.insertOrUpdate({
        data: data.map((item) => this.normalizeItem(item)),
      });
    }

    if (meta) {
      await this.commit((state) => {
        state.total = meta.total;
        state.perPage = meta.per_page;
        state.currentPage = meta.current_page;
        state.lastPage = meta.last_page;
      });
    }

    return request;
  }

  static async fetchUnreadCount() {
    const request = await this.api().fetchUnreadCount();
    const count = request.response?.data?.data?.count
      ?? request.response?.data?.data?.unreadCount
      ?? request.response?.data?.count
      ?? 0;

    await this.commit((state) => {
      state.unreadCount = count;
    });

    return count;
  }

  static setUnreadCount(count) {
    return this.commit((state) => {
      state.unreadCount = count;
    });
  }

  static handleSent(data) {
    const notification = data?.notification || data?.data || data;

    if (!notification?.id) {
      return null;
    }

    return this.insertOrUpdate({ data: this.normalizeItem(notification) });
  }

  static handleUnreadCounterUpdated(data) {
    const count = data?.count ?? data?.unreadCount ?? data?.unread_count ?? 0;
    return this.setUnreadCount(count);
  }

  static apiConfig = {
    actions: {
      fetchAll(params = {}) {
        return this.get('system-notifications', { params });
      },
      markAsRead(ids) {
        const payload = ids?.length ? { ids } : {};
        return this.post('system-notifications/mark-as-read', payload, { save: false });
      },
      fetchUnreadCount() {
        return this.get('system-notifications/unread-count', { save: false });
      },
    },
  }
}
